import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactGA from "react-ga";

export default function withTracker(WrappedComponent, options = {}) {
  const trackPage = (page) => {
    ReactGA.set({
      page,
      ...options,
    });
    ReactGA.pageview(page);
  };

  const HOC = class extends Component {
    static propTypes = {
      location: PropTypes.shape({
        pathname: PropTypes.string,
      }).isRequired,
    };

    componentDidMount() {
      const { location } = this.props;
      const page = location.pathname;
      trackPage(page);
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
      const { location } = this.props;
      const currentPage = location.pathname;
      const { location: nextLocation } = nextProps;
      const nextPage = nextLocation.pathname;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
}
